import React from "react";
import Card from "react-bootstrap/Card";
import Dropdown from "react-bootstrap/Dropdown";
import Calculator from "./CalculatorComponent/Calculator";
import NumberQuestion from "./numberQuestion/numberQuestion";
import QuestionButtonsContainer from "./questionButtonsContainer";
import "./ExamLayout.scss";
import { handleSubmitModalChange } from "../../redux/features/timer/timerSlice";
import { useDispatch } from "react-redux";
import PaginateBox from "./PaginateBox/PaginateBox";
import QuestionsContent from "./QuestionsContent";

function ExamLayout() {
  const dispatch = useDispatch();

  return (
    <div>
      <Card style={{ minHeight: "70vh" }}>
        <div className="w-100">
          <div className="py-2 px-3">
            <h6 className="text-primary py-1 mb-0">Objective</h6>
          </div>
          <hr className="m-0"></hr>

          <div className=" px-3 py-2 question-card">
            <div className="d-flex justify-content-center pb-5 options-header">
              <NumberQuestion />
              <div className="calc-absolute">
                <Dropdown>
                  <Dropdown.Toggle
                    className="calculator-btn btn rounded"
                    id="dropdown-basic"
                  >
                    Calculator
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Calculator />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <QuestionsContent />
            <div className="question-box"></div>
            <div className="d-flex justify-content-center pt-1 w-100">
              <PaginateBox />
              <div className="">
                {/* {JSON.stringify(allQuestions[0], 2)} */}

                <button
                  className="btn btn-success"
                  onClick={() => dispatch(handleSubmitModalChange())}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <hr></hr>
          <QuestionButtonsContainer />
        </div>
      </Card>
    </div>
  );
}

export default ExamLayout;
